// import React, { useState } from "react"
// import { useSelector, useDispatch } from "react-redux"
import NumberFormat from "react-number-format"

import '../../../assets/style/tablesG.css'
import iconCandado from '../img/tabla/iconCandado.svg'
// import { TextField } from "@mui/material"

export const TablaInvoice = ({ dataForm, handleChangeItemsTotals, handleChangeItemsName }) => {
    /* console.log('dataForm en tabla', dataForm) */

    const { separacion_miles, separacion_decimales, simbolo, items: detailInvoice = [] } = dataForm

    return (
        <table className="table">
            <thead className='p-thead-global'>
                <tr className="text-center TrTitlesTable">
                    <th scope="col" width="40%">Descripción</th>
                    <th scope="col" width="20%">Cantidad</th>
                    <th scope="col" className="Col-112" width="20%">
                        <div className="justify-content-center">
                            Monto base a facturar
                        </div>
                    </th>
                    <th scope="col" className="Col-112 ColumnGray" width="20%">
                        <div className="justify-content-center">
                            <img src={iconCandado} alt="no editable" />
                            <span className='ms-1'>Subtotal</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                {detailInvoice.length > 0 && detailInvoice?.map((item) => {
                    return (
                        <tr className='TrBodyTable' key={item.id}>
                            <td style={{ paddingLeft: '33px' }}>
                                <textarea
                                    className="p-text-item"
                                    name="nombre"
                                    id="outlined-size-small"
                                    value={item.nombre || ''}
                                    placeholder='Ingrese detalle'
                                    onChange={(e) => handleChangeItemsName(e, item.id)}
                                    disabled={dataForm.reading_mode}
                                >
                                </textarea>
                            </td>
                            <td>
                                <NumberFormat
                                    className='cantidades-item mt-2'
                                    value={item.cantidad}
                                    prefix={''}
                                    onValueChange={(values) => handleChangeItemsTotals(values, 'cantidad', item.id)}
                                    disabled={dataForm.reading_mode}
                                />
                            </td>
                            <td className="TextCenter">
                                <NumberFormat
                                    className='cantidades-item mt-2'
                                    value={item.precio_unitario}
                                    thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    prefix={`${simbolo} `}
                                    onValueChange={(values) => handleChangeItemsTotals(values, 'precio_unitario', item.id)}
                                    // onFocus={() => handleCheckDecimal(4)}
                                    // onBlur={() => handleCheckDecimal(2)}
                                    disabled={dataForm.reading_mode}
                                    decimalScale={2}
                                    fixedDecimalScale
                                />
                            </td>
                            <td className="TextRight ColumnGray">
                                <div className='mt-2'>
                                    <NumberFormat
                                        style={{ border: 'none' }}
                                        className='cantidades-item'
                                        value={item.subtotal}
                                        displayType={'text'}
                                        thousandSeparator={separacion_miles}
                                        decimalSeparator={separacion_decimales}
                                        prefix={`${simbolo} `}
                                        disabled={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />
                                </div>

                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}